import ENTES_FISCALIZADORES from '@/graphql/querys/administracion/catalogos/entesfiscalizadores/entesFiscalizadores.gql';
import AGREGAR_AUDITORIA from '@/graphql/mutations/administracion/auditorias/agregarAuditoria.gql';
import REMOVER_AUDITORIA from '@/graphql/mutations/administracion/auditorias/removerAuditoria.gql';
import ACTUALIZAR_AUDITORIA from '@/graphql/mutations/administracion/auditorias/actualizarAuditoria.gql';
import AUDITORIAS from '@/graphql/querys/administracion/auditorias/auditorias.gql';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  apollo: {
    entesFiscalizadores: {
      query: ENTES_FISCALIZADORES,
    },
  },
  mixins: [mixSubirArchivo],
  methods: {
    async mixActualizarAuditoria() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_AUDITORIA,
        variables: {
          id: this.auditoriaEditar.id,
          auditoria: this.auditoria,
        },
        update: (store, { data: { actualizarAuditoria } }) => {
          const data = store.readQuery({ query: AUDITORIAS });
          const { auditorias } = data;
          const index = auditorias
            .findIndex((auditoria) => auditoria.id === actualizarAuditoria.id);
          if (index !== -1) {
            auditorias.splice(index, 1, actualizarAuditoria);
          }
          store.writeQuery({ query: AUDITORIAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixAgregarAuditoria() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA,
          variables: { auditoria: this.auditoria },
          update: (store, { data: { agregarAuditoria } }) => {
            const data = store.readQuery({ query: AUDITORIAS });

            data.auditorias.push(agregarAuditoria);
            store.writeQuery({ query: AUDITORIAS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarAuditoria() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idAuditoria = this.auditoria.id;
      await this.$apollo.mutate({
        mutation: REMOVER_AUDITORIA,
        variables: {
          id: idAuditoria,
        },
        update: (store) => {
          const query = {
            query: AUDITORIAS,
          };
          const data = store.readQuery(query);
          const index = data.auditorias
            .findIndex(({ id }) => id === idAuditoria);
          if (index !== -1) {
            data.auditorias.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixGetPdf(publicKey) {
      return this.axios.get(
        `${BASE_URL}/${publicKey}`,
        {
          responseType: 'blob',
        },
      )
        .then((res) => ({
          data: res.data,
        }))
        .catch((err) => {
          this.mixMensajeError(err.data.message);
          return {
            err: err.data.message,
          };
        });
    },
  },
  computed: {
    getEntesFiscalizadores() {
      if (!this.entesFiscalizadores) return [];
      return this.entesFiscalizadores;
    },
  },
};
